import { createReducer, combineReducers, on } from '@ngrx/store';
import { UserActions } from './user.actions';

export interface UserData {
  userId: string
  accountCreationDate: string
  email: string
  groupId?: string
  name: string
  openRenderPipelineId?: string
  admin?: boolean
  activeSubscription?: string
  credits?: number
}

export const userReducer = createReducer<UserData | undefined>(
  undefined,
  on(UserActions.updateData, (_state, {data}) => data)
)

